import { SearchInput } from "@dust-tt/sparkle";
import { useLingui } from "@lingui/react/macro";
import { useEffect, useRef } from "react";

interface SidebarSearchProps {
  titleFilter: string;
  onTitleFilterChange: (value: string) => void;
}

export function SidebarSearch({
  titleFilter,
  onTitleFilterChange,
}: SidebarSearchProps) {
  const { t } = useLingui();
  const searchInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        e.key === "Escape" &&
        document.activeElement === searchInputRef.current
      ) {
        e.preventDefault();
        onTitleFilterChange("");
        searchInputRef.current?.blur();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onTitleFilterChange]);

  return (
    <SearchInput
      ref={searchInputRef}
      name="search"
      placeholder={t`Search`}
      value={titleFilter}
      onChange={onTitleFilterChange}
    />
  );
}
